import React from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import {Grid, GridItem} from '../grid'
import Price from '../price'
import Input from '../input'

const priceClassNames = props => [
  props.total ? css.total : '',
  props.grandTotal ? css.grandTotal : '',
  css.price
].join(' ')

const nameClassNames = props => [
  props.total ? css.total : '',
  props.grandTotal ? css.grandTotal : '',
  css.name
].join(' ')

const OrderLine = props => (
  <Grid>
    <GridItem col='1/2'><div className={nameClassNames(props)}>{props.name}</div></GridItem>
    <GridItem col='1/2'><Price price={props.price} styleClass={priceClassNames(props)} /></GridItem>
  </Grid>
)

const OrderLineInput = props => (
  <Grid>
    <GridItem col='1/2'><div className={nameClassNames(props)}>{props.name}</div></GridItem>
    <GridItem col='1/2'>
      <Input sm flex right
        type='number'
        styleClass={priceClassNames(props)}
        {...props}
      />
    </GridItem>
  </Grid>
)

OrderLine.propTypes = {
  name: PropTypes.any.isRequired, // TODO: check for string or DiamondName or JewelryName
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  total: PropTypes.bool,
  grandTotal: PropTypes.bool
}

export {OrderLine, OrderLineInput}



// WEBPACK FOOTER //
// ./src/components/order-line/index.js